import createEnum from 'scripts/lib/create_enum';

export default createEnum('AVAILABLE', 'DELETED', 'ERROR');



// WEBPACK FOOTER //
// ./src/scripts/domain/models/recording_status.js